import { getDayMonthTodayString, getDayMonthTomorrowString } from 'utils/get-day-month-string';

export const intros = ['В пункте выдачи ', 'Доставим '];
export const introsKz = ['Беру пунктінде ', 'Жеткіземіз '];

export function getDeliveryTermText(text: string, lang: string): string {
  if (lang === 'kk') {
    introsKz.forEach((intro) => {
      if (text.includes(intro)) {
        const str = text.split(intro)[1];

        if (str === getDayMonthTodayString(lang)) {
          text = `${intro}бүгін`;
        }

        if (str === getDayMonthTomorrowString(lang)) {
          text = `${intro}ертең`;
        }
      }
    });
  } else {
    intros.forEach((intro) => {
      if (text.includes(intro)) {
        const str = text.split(intro)[1];

        if (str === getDayMonthTodayString(lang)) {
          text = `${intro}сегодня`;
        }

        if (str === getDayMonthTomorrowString(lang)) {
          text = `${intro}завтра`;
        }
      }
    });
  }

  return text;
}
